import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { createExternalTrainingModuleImport } from '~/monolith-api';

const createImportOptionsSchema = z.object({
   type: z.enum(['URL', 'FILE_UPLOAD']),
   sourceName: z.string(),
   allowDuplicateSourceName: z.boolean().optional(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const {
         type,
         sourceName,
         allowDuplicateSourceName = false,
      } = createImportOptionsSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await createExternalTrainingModuleImport(
         type,
         sourceName,
         allowDuplicateSourceName,
         {
            apiClient: monolithClient,
         }
      );
      res.status(200).json(result);
   },
});

export const createImportFromClient = (
   type: 'URL' | 'FILE_UPLOAD',
   sourceName: string,
   allowDuplicateSourceName: boolean = false
): ReturnType<typeof createExternalTrainingModuleImport> => {
   return bff()
      .post('/external-training-modules/createImport', {
         type,
         sourceName,
         allowDuplicateSourceName,
      })
      .then(response => response.data);
};
